import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_HEALTH_INSURANCE } from './get-health-insurance.hook';
import { GET_HEALTH_INSURANCE_BY_ID } from './get-health-insurance-by-id.hook';
import { GET_HEALTH_INSURANCE_BY_IDS } from './get-health-insurance-by-ids.hook';
import { GET_ALL_HEALTH_INSURANCE } from './get-all-health-insurance.hook';

export const CREATE_HEALTH_INSURANCE = gql`
  mutation createHealthInsurance($payload: CreateHealthInsuranceInput!) {
    createHealthInsurance(payload: $payload) {
      _id
      name
      companyId
    }
  }
`;

export const useCreateHealthInsurance = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('settings');
  const [createHealthInsurance, { loading }] = useMutation(CREATE_HEALTH_INSURANCE, {
    onCompleted: data => {
      if (data?.createHealthInsurance?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('healthInsurance.notifications.created'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [
      GET_HEALTH_INSURANCE,
      GET_HEALTH_INSURANCE_BY_ID,
      GET_HEALTH_INSURANCE_BY_IDS,
      GET_ALL_HEALTH_INSURANCE,
    ],
  });
  return { createHealthInsurance, loading };
};
